import {
    SET_ACCOUNT_DETAILS,
    CLEAR_ACCOUNT_DETAILS,
} from '../../actions'

const initialState = {
    id: undefined,
    name: undefined,
    email: undefined,
    authenticated: false,
    loading: false,
    errorMessage: undefined
}

const details = (state = initialState, action) => {
    switch (action.type) {
        case SET_ACCOUNT_DETAILS:
            return {
                ...state,
                ...action.payload,
                authenticated: true
            };
        case CLEAR_ACCOUNT_DETAILS:
            return {
                ...initialState,
                authenticated: false
            };

        default:
            return state
    }
}

export default details



// WEBPACK FOOTER //
// ./src/reducers/account/details.js